import { render, staticRenderFns } from "./PradoSur.vue?vue&type=template&id=c86e0964"
import script from "./PradoSur.vue?vue&type=script&lang=js"
export * from "./PradoSur.vue?vue&type=script&lang=js"
import style0 from "./PradoSur.vue?vue&type=style&index=0&id=c86e0964&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports